@if (items()?.length) {
	@for (item of items(); track item) {
		@if (isItemHeadline(item)) {
			<div class="navHeadline">
				<span>{{ item.name || (item.nameKey | msgKey) }}</span>
			</div>
			@if (item?.children?.length) {
				<bas-side-nav-hotlink
					[items]="item.children"
					[topLevel]="true"
				></bas-side-nav-hotlink>
			}
		} @else {
			<bas-side-nav-item
				[item]="item"
				[class.hasChildren]="item.children?.length"
			></bas-side-nav-item>
			@if (showChildren(item)()) {
				<bas-side-nav-hotlink
					[items]="item.children"
				></bas-side-nav-hotlink>
			}
		}
	}
}
